import React from "react";
import "./Contact.scss";
import { Mail, User, MessageCircle, Send } from "lucide-react";
import {
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaGithub,
  FaTiktok,
} from "react-icons/fa";

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-title-contact">Contact Me</div>
        <div className="contact-content">
          <div className="contact-left-content">
            <div className="contact-left">
              <h2 className="contact-title">Get in Touch</h2>
              <p>Have something to discuss? Send me a message and let's talk</p>
              <form className="contact-form">
                <div className="input-group">
                  <User size={18} />
                  <input type="text" placeholder="Your Name" />
                </div>
                <div className="input-group">
                  <Mail size={18} />
                  <input type="email" placeholder="Your Email" />
                </div>
                <div className="input-group textarea">
                  <MessageCircle size={19} />
                  <textarea rows="5" placeholder="Your Message"></textarea>
                </div>
                <button className="send-btn">
                  <Send size={16} />
                  Send Message
                </button>
              </form>
            </div>
          </div>
          {/*social*/}
          <div className="contact-right-content">
            <div className="contact-right">
              <h3>Connect With Me</h3>
              <div className="social-grid">
                <a
                  href="https://www.linkedin.com/in/khanh-bui-quoc-6a8195305/"
                  className="social-card linkedin"
                >
                  <FaLinkedin size={20} />
                  <div>
                    <h4>LinkedIn</h4>
                    <p>@Khanh Bui Quoc</p>
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/this.khanhbuii?fbclid=IwY2xjawLVDPNleHRuA2FlbQIxMABicmlkETFtWUNnb2FibzJ6QVd2MVQ2AR4W7fifQ7nXDa0UE1sXJYmcpA9tjWX1X76Logr912s3McAyIC-6Sk4cy8v2GQ_aem_c7sPOwugtyfWiegmSUVd3g"
                  className="social-card instagram"
                >
                  <FaInstagram size={20} />
                  <div>
                    <h4>Instagram</h4>
                    <p>@this.khanhbuii</p>
                  </div>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCViKnbABs6y9yxP9BuaK7wg"
                  className="social-card youtube"
                >
                  <FaYoutube size={20} />
                  <div>
                    <h4>Youtube</h4>
                    <p>@QuocKhanhBui</p>
                  </div>
                </a>
                <a href="https://github.com/BuiQuocKhanh-VKU" className="social-card github">
                  <FaGithub size={20} />
                  <div>
                    <h4>Github</h4>
                    <p>@BuiQuocKhanh-VKU</p>
                  </div>
                </a>

                <a
                  href="https://www.tiktok.com/@0905_bqk?is_from_webapp=1&sender_device=pc"
                  className="social-card tiktok"
                >
                  <FaTiktok size={20} />
                  <div>
                    <h4>Tiktok</h4>
                    <p>@Cơm thố gà</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
